var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconChangeModel = function SvgIconChangeModel(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#222",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "m16.504 14.75 2.75-.687.687 2.75"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#222",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "M19.253 14.063a9.3 9.3 0 0 1-8.25 6.187 8.25 8.25 0 0 1-7.755-5.431M5.504 7.25l-2.75.688-.688-2.75"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#222",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "M2.754 7.938c1.155-3.163 4.702-6.188 8.25-6.188a8.25 8.25 0 0 1 7.755 5.5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#222",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "M8.956 8.89a2.039 2.039 0 1 0 4.076.097 2.039 2.039 0 0 0-4.076-.097M14.519 14.637a3.537 3.537 0 0 0-7.048 0"
  })));
};
export default SvgIconChangeModel;